export enum Notification {
  NOTIFICATION_ACTIONS = 'NotificationActions',
  NOTIFICATION_CLOSE_PANEL = 'NotificationClosePanel',
  NOTIFICATION_COUNT = 'NotificationCount',
}
